const icon = require('vue-svgicon');
icon.register({
    'recipe-sph': {
        width: 41,
        height: 41,
        viewBox: '0 0 41 41',
        data: `<path pid="0" d="M20.4 39.8c10.714 0 19.4-8.686 19.4-19.4C39.8 9.686 31.114 1 20.4 1 9.686 1 1 9.686 1 20.4c0 10.714 8.686 19.4 19.4 19.4z" _stroke="#010101" stroke-width="1.2"/><path pid="1" d="M20.4 39.8c6.76 0 12.24-8.686 12.24-19.4C32.64 9.686 27.16 1 20.4 1S8.16 9.686 8.16 20.4c0 10.714 5.48 19.4 12.24 19.4z" _stroke="#010101" stroke-width="1.2"/><path pid="2" d="M1 19.91c0 2.68 8.69 4.85 19.4 4.85 10.71 0 19.4-2.17 19.4-4.85M5.38 8.03c0 2.07 6.71 3.75 14.99 3.75 8.28 0 14.99-1.68 14.99-3.75M37.68 29.26c-1.42 3.02-8.61 5.32-17.26 5.32-8.65 0-15.73-2.26-17.23-5.25M20.4 1v38.8" _stroke="#010101" stroke-width="1.2"/>`,
    },
});
